import { AppLayoutBreakpoint } from '../../../../util/responsiveness';

export const showSubHeaderBreakpoint = AppLayoutBreakpoint.Width812;

export interface SubHeaderRowProps {
  /**
   * Optional prop make the subheader visible at all breakpoints.
   * Defaults to `false` which makes the subheader visibile only in narrow screen widths.
   */
  readonly forceVisibleAtAllBreakpoints?: boolean;
}
